module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("企业信息介绍")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "list-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/recordInformation/11.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_vm._v(_vm._s(_vm.positionItem.name))])]), _vm._v(" "), _c('div', {
    staticClass: "list-item"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "src": require("../../../../static/img/recordInformation/12.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_vm._v(_vm._s(_vm.positionItem.address))])]), _vm._v(" "), _c('div', {
    staticClass: "list-item"
  }, [_c('img', {
    staticClass: "img2",
    attrs: {
      "src": require("../../../../static/img/recordInformation/6.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_vm._v(_vm._s(_vm.positionItem.phone))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-item list-item1"
  }, [_c('img', {
    staticClass: "img3",
    attrs: {
      "src": require("../../../../static/img/recordInformation/7.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_vm._v("可追溯商品 12 种")]), _vm._v(" "), _c('div', {
    staticClass: "trace-pro"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/recordInformation/3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/recordInformation/3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/recordInformation/3.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-item"
  }, [_c('img', {
    staticClass: "img2",
    attrs: {
      "src": require("../../../../static/img/recordInformation/10.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_vm._v("溯源基地 2 个")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-item"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/recordInformation/8.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_vm._v("气象设备2台")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-item"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "src": require("../../../../static/img/recordInformation/9.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_vm._v("监控设备14台")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09df73f1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/recordInformation/detail/index.vue
// module id = 1928
// module chunks = 2